<template>
    <Toast
        group="secondarynotification"
        position="bottom-right"
        :style="{ width: '30rem' }">
        <template #message="{ message }">
            <div class="flex align-items-start flex-1 p-2">
                <i
                    :class="[
                        message.icon ?? 'far fa-circle-info',
                        'text-blue-500',
                    ]"
                    class="text-2xl mr-3"></i>
                <div>
                    <span
                        v-if="message.venueName"
                        class="block text-sm text-600 mb-1">
                        {{ message.venueName }}
                    </span>
                    <span class="text-xl font-medium text-900">{{
                        message.summary
                    }}</span>

                    <p v-if="message.detail" class="text-700 mt-3">
                        {{ typeof message.detail === 'string' ? message.detail : message.detail.content }}
                    </p>

                    <div v-if="message.url && message.label" class="mt-3">
                        <router-link :to="message.url">
                            <Button
                                :label="message.label"
                                :severity="message.severity"
                                size="small" />
                        </router-link>
                    </div>
                </div>
            </div>
        </template>
    </Toast>
</template>

<script setup>
import Toast from "primevue/toast";

// Dismiss the message when the cta is clicked
</script>
